const ERROR = "ERROR"
const CHOICE = "CHOICE"
const DEALING = "DEALING"
const GAME = "GAME"
const LOADING = "LOADING"

export { ERROR, CHOICE, DEALING, GAME, LOADING }